.product {
    font-family: var(--mantine-font-family-monospace);
    font-weight: 700;
    font-size: var(--mantine-font-size-xs);
    letter-spacing: 0.0875em;
    text-transform: uppercase;
}
